import React from 'react';
import { Link } from 'react-router-dom';


const Footer = () => {
  return (
    <footer>
      <div className="rx-main-footer padding-tb-50">
        <div className="container">
          <div className="row mb-minus-24">
            {/* Logo and Social Media Section */}
            <div className="col-lg-3 col-sm-6 col-12 mb-24 footer-order-1">
              <div className="rx-social-media">
                <div className="rx-logo">
                  <img src="img/logo/logo.jpg" alt="logo" />
                </div>
                <div className="inner-contact">
                  <p>
                  Om Sai PG offers comfortable and affordable accommodation in Kharadi, Pune. Fully furnished rooms with amenities like home-cooked meals, high-speed Wi-Fi, 24/7 security, and housekeeping services make it the perfect choice for students and professionals. 
                  </p>
                </div>
               

                  <a href="tel:+91 9763888448">
                     
                      <div>
                       <i class="bi bi-telephone-fill fs-3 text-white me-2"></i>
                        <a href="tel:+91 9763888448" className="text-white">+91 9763888448</a>
                      </div>
                    </a>

                    <a href="tel:+91 9922248255">
                     
                      <div>
                      <i class="bi bi-telephone-fill fs-3 text-white me-2"></i>
                        <a href="tel:+91 9922248255"  className="text-white">+91 9922248255</a>
                      </div>
                    </a>
              </div>
            </div>

            {/* Explore Section */}
            <div className="col-lg-3 col-sm-4 col-6 col-420-full mb-24 footer-order-2">
              <div className="rx-footer-items">
                <div className="rx-items-heading">
                <h3 className=''>Service</h3>
                </div>
                <div className="rx-items-contact">
                  <ul>
                    <li>
                      <Link to="PG-In-Pune"><i class="bi bi-house-door-fill"></i> PG In Pune</Link>
                    </li>
                    
                    <li>
                      <Link to="/Single-Room-PG-in-Pune"><i class="bi bi-house-door-fill"></i> Single Room PG in Pune</Link>
                    </li>
                    <li>
                      <Link to="/PG-in-Kharadi"><i class="bi bi-house-door-fill"></i> PG in Kharadi</Link>
                    </li>

                    <li>
                      <Link to="/Best-Luxury-PG-in-Pune"><i class="bi bi-house-door-fill"></i> Best Luxury PG in Pune</Link>
                    </li>
                
                    <li>
                      <Link to="/Best-PG-Near-Eon-IT-Park-Kharadi"><i class="bi bi-house-door-fill"></i> Best PG Near Eon IT Park Kharadi</Link>
                    </li>

                    <li>
                      <Link to="/Hostel-in-Kharadi"><i class="bi bi-house-door-fill"></i> Hostel in Kharadi</Link>
                    </li>
                    <li>
                      <Link to="/Om-Sai-PG-Kharadi"><i class="bi bi-house-door-fill"></i> Om Sai PG Kharadi</Link>
                    </li>

                    <li>
                      <Link to="/Paying-Guest-in-Kharadi"><i class="bi bi-house-door-fill"></i> Paying Guest in Kharadi</Link>
                    </li>

                    <li>
                      <Link to="/PG-in-Kharadi-for-male"><i class="bi bi-house-door-fill"></i> PG in Kharadi for male </Link>
                    </li>
                    <li>
                      <Link to="/Pg-in-Wagholi"><i class="bi bi-house-door-fill"></i> PG in Wagholi</Link>
                    </li>
                    <li>
                      <Link to="/PG-in-Kharadi-With-Food"><i class="bi bi-house-door-fill"></i> PG in Kharadi With Food</Link>
                    </li>
                    <li>
                      <Link to="/Hostels-in-Pune"><i class="bi bi-house-door-fill"></i> Hostels in Pune</Link>
                    </li>

                    <li>
                      <Link to="/Paying-Guest-Hostel-in-Chandan-Nagar"><i class="bi bi-house-door-fill"></i> Paying Guest Hostel in Chandan Nagar</Link>
                    </li>
                    
                  </ul>
                </div>
              </div>
            </div>

            {/* City Branches Section */}
            <div className="col-lg-3 col-sm-4 col-6 col-420-full mb-24 footer-order-3">
              <div className="rx-footer-items">
                <div className="rx-items-heading">
                  <h3 className=''>Service</h3>
                </div>
                <div className="rx-items-contact">
                  <ul>
                  <li>
                      <Link to="/PG-for-Working-Professionals-Pune"><i class="bi bi-house-door-fill"></i> PG for Working Professionals Pune</Link>
                    </li>

                    <li>
                      <Link to="/Luxury-PG-in-Kharadi"><i class="bi bi-house-door-fill"></i> Luxury PG in Kharadi</Link>
                    </li>

                    <li>
                      <Link to="/Paying-Guest-Near-Kharadi-IT-Park-Pune"> <i class="bi bi-house-door-fill"></i> Paying Guest Near Kharadi IT Park Pune </Link>
                    </li>

                    <li>
                      <Link to="/PG-Near-Kharadi-Eon-IT-Park"> <i class="bi bi-house-door-fill"></i> PG Near Kharadi Eon IT Park</Link>
                    </li>
                    <li>
                      <Link to="/PG-Near-Kharadi-Bypass"><i class="bi bi-house-door-fill"></i> PG Near Kharadi Bypass</Link>
                    </li>

                    <li>
                      <Link to="/Wadgaon-Sheri-PG"><i class="bi bi-house-door-fill"></i> Wadgaon Sheri PG</Link>
                    </li>

                    
                    <li>
                      <Link to="/PG-in-Chandan-Nagar"><i class="bi bi-house-door-fill"></i> PG in in Chandan Nagar</Link>
                    </li>
                    <li>
                      <Link to="/Hostels-in-Kharadi"><i class="bi bi-house-door-fill"></i> Hostels in Kharadi</Link>
                    </li>
                    <li>
                      <Link to="/Girls-Hostels-in-Kharadi"><i class="bi bi-house-door-fill"></i> Girls Hostels in Kharadi</Link>
                    </li>

                    <li>
                      <Link to="/Boys-Hostel-in-Kharadi"><i class="bi bi-house-door-fill"></i> Boys Hostel in Kharadi</Link>
                    </li>

                    <li>
                      <Link to="/Monthly-Basis-PG-in-Kharadi"><i class="bi bi-house-door-fill"></i> Monthly Basis PG in Kharadi</Link>
                    </li>
                    <li>
                      <Link to="/PG-for-Students-in-Kharadi-Pune"><i class="bi bi-house-door-fill"></i> PG for Students in Kharadi Pune</Link>
                    </li>

            
                  </ul>
                </div>
              </div>
            </div>

          

            {/* Other Info Section */}
            <div className="col-lg-3 col-sm-6 col-6 col-420-full mb-24 footer-order-5">
              <div className="rx-footer-other-info">
                <div className="inner-info">
                  <h3 className='add-text'>Address</h3>
                  <p className='text-white'>Om Sai PG <br/>
                Tulja Bhavani Nagar,
                Lane No 7,<br/>
                Near Durga Mata Mandir,<br/>
                Kharadi Pune - 411014.</p>

                <div>
                  <p><span className='text-white'>Mobile Number</span> : +91 9763888448 / +91 9922248255</p>
                </div>
              
                </div>
                <div className="inner-info">
                  <h5>Email</h5>
                  <a href="mailto:omsaipgpune@gmail.com">omsaipgpune@gmail.com</a>
                </div>
                <div className="inner-info">
    <div style={{ position: 'relative', overflow: 'hidden', paddingTop: '', height: '300px', maxWidth: '100%' }}>
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d56881.68616005074!2d73.88729343290177!3d18.55597545061753!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c3f1982d6b2b%3A0x74125aedd2bd98c6!2sOM%20SAI%20PG!5e1!3m2!1sen!2sin!4v1740637774676!5m2!1sen!2sin"
        width="100%"
        height="250"
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Om Sai PG Location"
      ></iframe>
    </div>



        </div>
              </div>
            </div>
          </div>
        </div>
      </div>


       {/* <!-- =============== whatsapp and phone button =============== --> */}
       <div class="phone-float">
                <a href="tel:+919763888448">
                <i class="bi bi-telephone-fill"></i><span>Call Us
                        <br/><small>+91 9763888448</small></span>
                </a>
            </div>

            <div class="whats-float">
                <a href="https://api.whatsapp.com/send/?phone=9763888448&text=I would like to inquire about booking a room at your Om Sai PG. Kindly provide me with more details or contact me . Thank you!!!"  target="_blank">
                    <span>WhatsApp<br/><small style={{ textAlign: 'right' }}>+91 9763888448</small></span><i
                        class="bi bi-whatsapp"></i>
                </a>
            </div>

      {/* Footer Copy Section */}
      <div className="rx-footer-copy">
        <div className="container"> 
          <div className="row">
            <div className="col-12">
              <div className="rx-footer-inner-contact">
        

              <div className="text-white">
  All rights reserved <span className='text-yellow fw-bold'>Om Sai PG</span> {new Date().getFullYear()} Developed By
  <Link to="https://dexterintelligence.com/" target="_blank"> <span className="text-yellow fw-bold">Dexter Intelligence</span> </Link> |  <Link to='https://www.urvahosting.com/' target="_blank" className='text-white'>Hosted By <span className="text fw-bold text-yellow">Urva Hosting</span></Link> 
</div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
